import { z } from 'zod'

/** Medical deferral off the lab results — both fields are required by the API. */
export const labDeferralSchema = (t: (key: string) => string) =>
  z.object({
    reason: z
      .string()
      .trim()
      .min(1, t('donor_detail.lab_research.decision.reason_required')),
    deferral_end_date: z
      .string()
      .min(1, t('donor_detail.lab_research.decision.date_required')),
  })

export type LabDeferralFormValues = z.infer<
  ReturnType<typeof labDeferralSchema>
>
